<template>
  <div class="flex flex-wrap flex-col justify-center bg-gray-100">
    <main
      class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28 mb-5"
    >
      <div class="text-center">
        <h2
          class="text-2xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-3xl sm:leading-none md:text-4xl"
        >
          Get<span class="text-blue-400">Personal</span>
        </h2>
        <p
          class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
        >
          Create beautiful images for your tweets.
          <br />
          <!-- Get more engagment by tweeting images -->
        </p>
      </div>
    </main>
    <div class="flex flex-wrap justify-center">
      <Editor />
      <Sidebar />
    </div>
    <Promo />
    <Footer />
  </div>
</template>

<script>
import Sidebar from "../components/Common/Sidebar";
import Editor from "../components/Common/Editor";
import Promo from "../components/Common/Promo";

import Footer from "../components/Common/Footer";

export default {
  components: {
    Editor,
    Sidebar,
    Footer,
    Promo,
  },
};
</script>

<style lang="scss" scoped></style>
